/**
 * Authorization Roles
 */

export const ROLES = {
  ADMIN: 'internal.admin',
  ALL_CLAIMS_CYPRESS_USER: 'rr_cypress_user',
  TITLE_COMPANY: 'internal.titleCompany',
};

export const SKYNET_INTERNAL_COMPANY_ID = '209f3d98-ddb2-4b4e-a49d-aea896db02af';
